module.exports = __webpack_public_path__ + "img/code-js-md.837f1245.webp";